<section>
    <div class="page-title">
        <h2>{{ pageTitle }}</h2>
    </div>
    <div class="notification-banner" *ngIf="enableICOPPhaseOneSegSwitch && promotionsBanner">
        <xm-media-image [imageOptions]="promoIcon" size="width" center="vert" class="icon"></xm-media-image>
        <div class="notification-content">
            <ul class="description" *ngFor="let promo of promotionsBanner?.promotionContent?.promos">
                <li>{{ promo.text}}</li>
            </ul>
        </div>
    </div>
    <div *ngIf="showCompareTable">
        <table class="compare-table">
            <thead>
                <tr>
                    <th class="table-header">{{ cmsData.planSevenPlanChangeTable.currentTitle }}</th>
                    <th class="table-header">{{ cmsData.planSevenPlanChangeTable.newTitle }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let feature of compareFeatures">
                    <td class="table-data" *ngIf="feature.newPlanName">
                        <p class="feature-data">{{ feature.nickname }}</p>
                        <p class="feature-plan-name">{{ feature.currentPlanName }}</p>
                        <p class="feature-data">{{ feature.currentPlanDescription }}</p>
                    </td>
                    <td class="table-data" *ngIf="feature.newPlanName">
                        <p class="feature-data">{{ feature.nickname }}</p>
                        <p class="feature-plan-name">{{ feature.newPlanName }}</p>
                        <p class="feature-data">{{ feature.newPlanDescription }}</p>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="content">
        <div class="feature-content">
            <div class="image desktop">
                <xm-media-image [imageOptions]="imageIconPlanSix" size="auto" class="image-5g"></xm-media-image>
            </div>
            <div>
                <ng-container *ngFor="let featureGroup of pageData.planGroupInfo, let i = index">
                    <div [ngClass]="{'plan-seven-subheader': i === 0, 'subheader': i !== 0}">
                        {{ featureGroup.subheader }}
                    </div>
                    <div class="image mobile" *ngIf="i === 0">
                        <xm-media-image [imageOptions]="imageIconPlanSix" size="auto" class="image-5g"></xm-media-image>
                    </div>
                    <div class="feature-list" *ngFor="let feature of featureGroup.features">
                        <xm-media-image [imageOptions]="getImageOption(feature.icon)" size="height" class="icons"></xm-media-image>
                        <div class="feature-description">{{ feature.description }}</div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="time-info">
            <xm-media-image [imageOptions]="imageIconTimeInfo" size="auto" class="time-info-icon"></xm-media-image>
            <div class="time-info-description">{{ cmsData.timeInfo.description }}</div>
        </div>
        <div class="action">
            <button class="xm-btn-link-light left-btn" (click)="onCancel()">{{ cmsData.cancelBtn }}</button>
            <button class="xm-btn-primary-light" (click)="startUpgrade()">{{ upgradeBtn }}</button>
        </div>
    </div>
</section>
